import React from "react";
import styles from "./OpportunityLinkSuccess.module.scss";
import appStore from "../../assets/appStore.png";
import googlePlay from "../../assets/googlePlay.png";

function OpportunityLinkSuccess({ product, brand, opportunityVisibility }) {
  return (
    <div className={styles.mainContainer}>
      <div className={styles.stepSection}>
        <div className={styles.stepNumber}>
          <span>1</span>
        </div>

        {opportunityVisibility === "Private" ? (
          <>
            <label>
              Your application <br /> was sent!
            </label>
            <p>
              Your application to sell {product.name} has been sent to{" "}
              {brand.name} to review. When they respond, you’ll get an email.
            </p>
          </>
        ) : (
          <>
            <label>
              Congratulations on joining <br /> this opportunity!
            </label>
            <p>
              You're now partnered with {product.name}! The potential of this
              opportunity awaits you.
            </p>
          </>
        )}
      </div>

      <div className={styles.stepSection}>
        <div className={styles.stepNumber}>
          <span>2</span>
        </div>
        <label>Download the App!</label>

        {opportunityVisibility === "Private" ? (
          <p>
            Once your application is approved, use the Video Squirrel app to
            upload your videos or go live.
          </p>
        ) : (
          <p>
            Now that you're partnered with {product.name}, install the Video
            Squirrel app on your phone to begin uploading content.
          </p>
        )}

        <div className={styles.appLinks}>
          <a
            href="https://play.google.com/store/apps/details?id=com.zipline.native&hl=en"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.btnDownloadApp}
          >
            <img src={googlePlay} alt="" />
          </a>
          <a
            href="https://apps.apple.com/us/app/zipline-live-new/id1477631936?ls=1"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.btnDownloadApp}
          >
            <img src={appStore} alt="" />
          </a>
        </div>
      </div>

      <div className={styles.stepSection}>
        <div className={styles.stepNumber}>
          <span>3</span>
        </div>
        <label>
          Complete your <br /> profile!
        </label>
        <p>
          Remember that once you download the app to complete your profile. This
          helps better inform brands of who you are.
        </p>
      </div>
    </div>
  );
}

export default OpportunityLinkSuccess;
